import React from 'react'
import styled from 'styled-components'
import Featured from '../../assets/img/marketplace-static-images/Boudoir/Nikki Marketplace Photo.jpg'
import Family from '../../assets/img/marketplace-static-images/Family/Family - 3 - Ooh Ooh Darling Photography.jpg'
import Architecture from '../../assets/img/marketplace-static-images/Architecture _ Real Estate/Architecture + Real Estate - 2 - Marlboro Wang.jpg'
import Boudoir from '../../assets/img/marketplace-static-images/Boudoir/Boudoir - 1 - Olya Kobruseva.jpg'
import Branding from '../../assets/img/marketplace-static-images/Branding/Branding - 5 - Maria Orlova.jpg'
import CorporateEvent from '../../assets/img/marketplace-static-images/Corporate Events/Corporate Event - 3 - Helena Lopes.jpg'
import Event from '../../assets/img/marketplace-static-images/Events/Events - 2 - Laura Stanley.jpg'
import Headshots from '../../assets/img/marketplace-static-images/Headshots/Headshots - 7 - Greg Samborski.jpg'
import Newborn from '../../assets/img/marketplace-static-images/Newborn _ Maternity/Maternity + Newborn - 7 - Nellie Quail.jpg'
import Portraits from '../../assets/img/marketplace-static-images/Portraits/Portraits - 1 - Olivia Danielle.jpg'
import Product from '../../assets/img/marketplace-static-images/Product/Product - 2 - Karolina Grabowska.jpg'
import Wedding from '../../assets/img/marketplace-static-images/Wedding _ Engagement/Wedding + Engagement - 7 - Tasha Knight.jpg'

function StaticImage(props) {
  let staticImg
  switch (props.cat) {
    case '2' || 2:
      staticImg = Featured
      break
    case '3':
      staticImg = Headshots
      break
    case '4':
      staticImg = Family
      break
    case '5':
      staticImg = Newborn
      break
    case '6':
      staticImg = Wedding
      break
    case '7':
      staticImg = Portraits
      break
    case '8':
      staticImg = CorporateEvent
      break
    case '9':
      staticImg = Boudoir
      break
    case '10':
      staticImg = Product
      break
    case '11':
      staticImg = Architecture
      break
    case '12' || '13':
      staticImg = Event
      break
    case '14':
      staticImg = Branding
      break
    default:
      staticImg = Featured
  }
  return <Image src={staticImg} alt="Static" fixed={props.fixed} />
}

export default StaticImage

const Image = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  width: 41vw;
  z-index: -2;
  object-fit: cover;
  @media (max-width: 1400px) {
    width: 38vw;
    left: 62vw;
    height: calc(100vh - 120px);
  }
`
